import { useQuery } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import { JoinAChatRoomPayload } from "../../types";

export const useJoinChatRoom = (body: JoinAChatRoomPayload, enabled: boolean = false) => {
  const isValidRoomId = !!body.roomId;

  return useQuery({
    queryKey: ["chat", "joinRoom", body.roomId],
    queryFn: async () => {
      const response = await chatApi.joinAChatRoom(body);
      return response;
    },
    enabled: enabled && isValidRoomId,
    refetchOnMount: true,
    staleTime: 0, // Luôn refetch để đảm bảo dữ liệu phòng mới nhất
  });
};
